<template>
  <div>
    <div
      class="tw-flex tw-flex-col tw-mx-auto"
      style="max-width: 768px"
    >
      <h2 class="question-title-v2 tw-mb-4">
        {{ question.title }}
      </h2>
      <div
        class="accordion tw-mb-4"
        role="tablist"
      >
        <b-card
          v-for="(list, i) in question.displayArray"
          :key="i"
          no-body
          class="tw-mb-0"
          style="border: none"
        >
          <b-card-header
            header-tag="header"
            class="tw-p-1 tw-mb-4"
            role="tab"
            style="border: none"
          >
            <div
              v-b-toggle="'accordion-' + i"
              class="toggle-accordion bold d-letter-spacing"
            >
              <div>
                <span
                  class="h1 tw-mb-0"
                  style="color: #2c2660"
                >{{ list.title }}</span>
              </div>
              <span
                class="when-opened text-underline"
                style="color: #a783ff"
              >
                COLLAPSE
              </span>
              <span
                class="when-closed text-underline"
                style="color: #a783ff"
              >
                EXPAND
              </span>
            </div>
          </b-card-header>
          <b-collapse
            :id="'accordion-' + i"
            accordion="my-accordion"
            role="tabpanel"
            :visible="i === 0"
          >
            <b-card-text class="tw-pb-6 d-letter-spacing text-muted">
              {{ list.name }}
            </b-card-text>
          </b-collapse>
        </b-card>
      </div>
      <div>
        <b-button
          class="tw-px-6"
          variant="info"
          size="md"
          @click="onPrimary"
        >
          {{ question.answerlist[0].name }}
        </b-button>
        <div
          v-if="question.answerlist.length > 1"
          class="tw-mt-4 tw-pt-1"
        >
          <a
            href="javascript:void(0)"
            class="text-default text-underline"
            @click="onSecondary"
          >
            {{ question.answerlist[1].name }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: { type: Object, required: true },
  },
  methods: {
    onPrimary() {
      const a = this.question.answerlist[0];
      this.$emit('submitAnswer', { id: this.question.id, answer: a.id, answerBody: a });
    },
    onSecondary() {
      const a = this.question.answerlist[1];
      this.$emit('submitAnswer', { id: this.question.id, answer: a.id, answerBody: a });
    },
  },
};
</script>
